// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import API from "../services/api";
// import "./editAgentList.css";

// function EditAgentList() {
//   const [agents, setAgents] = useState([]);
//   const [search, setSearch] = useState("");
//   const navigate = useNavigate();

//   const fetchAgents = async () => {
//     try {
//       const res = await API.get("/agents/");
//       setAgents(res.data || []);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     fetchAgents();
//   }, []);

//   const filteredAgents = agents
//   .filter((a) => a.is_active === true) // ✅ ONLY ACTIVE
//   .filter((a) =>
//     (a.mobile_no || "").toString().includes(search)
//   );

//   return (
//     <div className="page">

//       {/* 🔥 HEADER */}
//       <div className="header">
//         <h1>👨‍💼 Agent Management</h1>
//         <p>Manage and update commission agents</p>
//       </div>

//       {/* 🔍 SEARCH */}
//       <div className="search-box">
//         <span className="search-icon">🔍</span>
//         <input
//           placeholder="Search by mobile number..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//       </div>

//       {/* EMPTY STATE */}
//       {filteredAgents.length === 0 && (
//         <div className="empty">
//           🚫 No agents found
//         </div>
//       )}

//       {/* 🔥 CARD GRID */}
//       <div className="grid">
//         {filteredAgents.map((a) => (
//           <div className="card" key={a.id}>

//             {/* TOP */}
//             <div className="card-top">
//               <h3>{a.name_as_per_pan}</h3>
//               <span className={`status ${a.is_active ? "active" : "inactive"}`}>
//                 {a.is_active ? "Active" : "Inactive"}
//               </span>
//             </div>

//             {/* INFO */}
//             <div className="info">
//               <p>📱 {a.mobile_no || "N/A"}</p>
//               <p>📧 {a.mail_id || "N/A"}</p>
//             </div>

//             {/* ACTION */}
//             <button
//               className="edit-btn"
//               onClick={() => navigate(`/edit/${a.id}`)}
//             >
//               ✏️ Edit Details
//             </button>

//           </div>
//         ))}
//       </div>

//     </div>
//   );
// }

// export default EditAgentList;








import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

function EditAgentList() {
  const [agents, setAgents] = useState([]);
  const [search, setSearch] = useState("");
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const navigate = useNavigate();

  // 🖱️ Mouse Tracking for Spotlight Effect
  useEffect(() => {
    const handleMouseMove = (e) => setMousePos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const fetchAgents = async () => {
    try {
      const res = await API.get("/agents/");
      setAgents(res.data || []);
    } catch (err) {
      console.log("Error fetching agents:", err);
    }
  };


 useEffect(() => {
  const handleKeyDown = (e) => {
    if (
      e.key === "F12" ||
      (e.ctrlKey && e.shiftKey && e.key === "I") ||
      (e.ctrlKey && e.shiftKey && e.key === "J") ||
      (e.ctrlKey && e.key === "U")
    ) {
      e.preventDefault();
    }
  };

  document.addEventListener("keydown", handleKeyDown);

  return () => {
    document.removeEventListener("keydown", handleKeyDown);
  };
}, []);

useEffect(() => {
  const handleContextMenu = (e) => e.preventDefault();
  document.addEventListener("contextmenu", handleContextMenu);

  return () => {
    document.removeEventListener("contextmenu", handleContextMenu);
  };
}, []);


  useEffect(() => {
    fetchAgents();
  }, []);

  const filteredAgents = agents
    .filter((a) => a.is_active === true) // ✅ ONLY ACTIVE
    .filter((a) =>
      (a.mobile_no || "").toString().includes(search) ||
      (a.name_as_per_pan || "").toLowerCase().includes(search.toLowerCase())
    );

  return (
    <div className="list-page-wrapper">
      <style>{`
        .list-page-wrapper {
          min-height: 100vh;
          background: #020617;
          color: white;
          font-family: 'Plus Jakarta Sans', sans-serif;
          padding: 60px 20px 120px 20px;
          position: relative;
          overflow-x: hidden;
        }

        .spotlight {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(59, 130, 246, 0.07) 0%, transparent 50%);
          z-index: 1; pointer-events: none;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        /* --- HEADER --- */
        .header {
          text-align: center;
          margin-bottom: 50px;
        }

        .header h1 {
          font-size: clamp(28px, 5vw, 40px);
          font-weight: 800;
          letter-spacing: -1.5px;
          background: linear-gradient(to right, #fff, #94a3b8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom: 10px;
        }

        .header p { color: #64748b; font-size: 16px; }

        /* --- SEARCH BOX --- */
        .search-container {
          display: flex;
          justify-content: center;
          margin-bottom: 40px;
        }

        .search-box {
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 12px 25px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          gap: 15px;
          width: 100%;
          max-width: 500px;
          backdrop-filter: blur(10px);
          transition: 0.3s;
        }

        .search-box:focus-within {
          border-color: #fbbf24;
          background: rgba(255, 255, 255, 0.05);
          box-shadow: 0 0 20px rgba(251, 191, 36, 0.1);
        }

        .search-box input {
          background: transparent;
          border: none;
          color: white;
          font-size: 16px;
          width: 100%;
          outline: none;
        }

        .search-icon { font-size: 18px; opacity: 0.5; }

        /* --- GRID & CARDS --- */
        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 25px;
        }

        .card {
          background: rgba(255, 255, 255, 0.02);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 24px;
          padding: 25px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .card:hover {
          transform: translateY(-5px);
          background: rgba(255, 255, 255, 0.04);
          border-color: rgba(251, 191, 36, 0.4);
        }

        .card-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 20px;
        }

        .card-top h3 {
          font-size: 18px;
          font-weight: 700;
          color: #f8fafc;
          max-width: 70%;
          line-height: 1.3;
        }

        .status {
          font-size: 10px;
          font-weight: 800;
          text-transform: uppercase;
          padding: 4px 10px;
          border-radius: 12px;
          letter-spacing: 0.5px;
        }

        .status.active { background: rgba(34, 197, 94, 0.1); color: #22c55e; }
        .status.inactive { background: rgba(239, 68, 68, 0.1); color: #ef4444; }

        .info {
          margin-bottom: 25px;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .info p {
          font-size: 14px;
          color: #94a3b8;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .edit-btn {
          width: 100%;
          padding: 12px;
          border-radius: 14px;
          border: 1px solid rgba(251, 191, 36, 0.3);
          background: rgba(251, 191, 36, 0.05);
          color: #fbbf24;
          font-weight: 700;
          cursor: pointer;
          transition: 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .edit-btn:hover {
          background: #fbbf24;
          color: #020617;
        }

        .empty {
          text-align: center;
          padding: 60px;
          background: rgba(255,255,255,0.02);
          border-radius: 30px;
          border: 1px dashed rgba(255,255,255,0.1);
          color: #64748b;
        }

        /* 📍 BACK BUTTON - BOTTOM LEFT */
        .back-btn-fixed {
          position: fixed;
          bottom: 30px;
          left: 30px;
          width:20rem;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: #94a3b8;
          padding: 14px 24px;
          border-radius: 16px;
          cursor: pointer;
          font-weight: 700;
          z-index: 100;
          transition: 0.3s;
          display: flex;
          
          align-items: center;
          gap: 10px;
        }

        .back-btn-fixed:hover {
          background: rgba(255, 255, 255, 0.1);
          color: white;
          transform: translateX(6px);
          border-color: #fbbf24;
        }

        @media (max-width: 768px) {
          .grid { grid-template-columns: 1fr; }
          .back-btn-fixed { bottom: 20px; left: 20px; padding: 12px 18px; font-size: 13px; }
        }
      `}</style>

      <div className="spotlight"></div>

      {/* 🔹 Navigation */}
      <button className="back-btn-fixed" onClick={() => navigate("/dashboard")}>
        <span>←</span> Back to Dashboard
      </button>

      <div className="container">
        {/* 🔥 HEADER */}
        <div className="header">
          <h1>👨‍💼 Agent Management</h1>
          <p>Search, filter, and modify your commission agent records</p>
        </div>

        {/* 🔍 SEARCH */}
        <div className="search-container">
          <div className="search-box">
            <span className="search-icon">🔍</span>
            <input
              placeholder="Search by name or mobile number..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* EMPTY STATE */}
        {filteredAgents.length === 0 && (
          <div className="empty">
            <div style={{fontSize: '40px', marginBottom: '10px'}}>🚫</div>
            <p>No active agents match your search criteria</p>
          </div>
        )}

        {/* 🔥 CARD GRID */}
        <div className="grid">
          {filteredAgents.map((a) => (
            <div className="card" key={a.id}>
              <div>
                <div className="card-top">
                  <h3>{a.name_as_per_pan || "Unnamed Agent"}</h3>
                  <span className={`status ${a.is_active ? "active" : "inactive"}`}>
                    {a.is_active ? "Active" : "Inactive"}
                  </span>
                </div>

                <div className="info">
                  <p><span>📱</span> {a.mobile_no || "N/A"}</p>
                  <p><span>📧</span> {a.mail_id || "N/A"}</p>
                  
                </div>
              </div>

              <button
                className="edit-btn"
                onClick={() => navigate(`/edit/${a.id}`)}
              >
                ✏️ Edit Profile Details
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EditAgentList;